module.exports = __webpack_public_path__ + "img/adinath_argo-icon.577a4a58.png";